import React, { PureComponent } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchErrors } from '../../actions/error_management'
import { manualAml } from '../../actions/manual-aml'
import { CalloutBox, DivContentBox } from '../common/styled'

class CorporateForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      full_name: '',
      show: false,
    }
  }

  validationMessage = (name) => {
    const { errors } = this.props
    if (errors && errors[name] && !this.state.formChanged) {
      return (
        <div>
          {errors[name].map((e, index) => (
            <span key={index} className='help-block'>
              {e}
            </span>
          ))}
        </div>
      )
    } else {
      return null
    }
  }

  changeHandler = ({ target }) => this.setState({ [target.name]: target.value, formChanged: true })

  validForm = () => {
    const { state } = this

    const validationResult = state.full_name.trim().length

    return validationResult
  }

  onSubmit = async () => {
    const { props, state } = this
    const payload = {
      full_name: state.full_name,
      aml_type: 'corporate',
    }

    this.setState({ show: true })
    await props.manualAml(payload)
    this.setState({
      loading: false,
      full_name: '',
    })
  }
  render() {
    const { state, props } = this
    const { loading, show } = state

    const { isFetching, results, disabled } = props

    return (
      <DivContentBox className='ibox-content animated fadeIn'>
        {results && results.message && show && (
          <Alert
            variant={
              results.message.includes('This feature has not been enabled for your account') ? 'danger' : 'success'
            }
            className='animated fadeIn'
            onDismiss={() => this.setState({ show: false })}
          >
            {results.message}
          </Alert>
        )}

        <CalloutBox>
          <h3>Instructions</h3>
          <p>Please enter the name of the business that you would like to run AML on.</p>
        </CalloutBox>
        <form className='form-horizontal'>
          <fieldset>
            <div className='form-group'>
              <label className='col-md-4 control-label' htmlFor='full_name'>
                Name of Corporate Entity
              </label>
              <div className='col-md-4'>
                <input
                  name='full_name'
                  required
                  placeholder='Name of Corporate Entity'
                  className='form-control input-md'
                  disabled={loading}
                  onChange={this.changeHandler}
                  value={state.full_name}
                />
                {this.validationMessage('full_name')}
              </div>
            </div>

            <div className='form-group'>
              <label className='col-md-4 control-label' />
              <div className='col-md-4'>
                {disabled && (
                  <Button variant='primary' disabled>
                    Submit Disabled
                  </Button>
                )}
                {!disabled && (
                  <Button
                    variant='primary'
                    onClick={this.onSubmit}
                    disabled={!this.validForm() || isFetching || disabled}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </div>
          </fieldset>
        </form>
      </DivContentBox>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  errorMessage: state.manualAml.errorMessage,
  errors: state.manualAml.errors,
  results: state.manualAml.results,
  isFetching: state.manualAml.isFetching,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manualAml,
      fetchErrors,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CorporateForm))
